import { generateContext } from '@btime/react-contexts'
import React, { useContext, useMemo, useState } from 'react'

const { StateContext, ActionsContext, Provider } = generateContext({})
export const useMapState = () => useContext(StateContext)
export const useMapActions = () => useContext(ActionsContext)

export const useZoomOnMarker = () => {
  const { zoom } = useMapState()
  const { setZoom, setCenter } = useContext(ActionsContext) || {}
  return (lat, lng) => {
    // To solve bug on centering two time the same marker
    setZoom(zoom === 15 ? 16 : 15)
    setCenter({ lat, lng })
  }
}

export const MapsContext = ({ defaultCenter, defaultZoom, ...props }) => {
  const [bounds, setBounds] = useState()
  const [center, setCenter] = useState(defaultCenter || { lat: -19.6341, lng: -43.9654 })
  const [zoom, setZoom] = useState(defaultZoom || 5)
  const [showUser, setShowUsers] = useState(false)
  const [showPlaces, setShowPlaces] = useState(false)
  const [route, setRoute] = useState([])
  const controller = useMemo(() => {
    return new window.AbortController()
  }, [])
  return (
    <Provider
      state={{ route, center, zoom, bounds, showUser, showPlaces, controller }}
      actions={{ setRoute, setZoom, setCenter, setBounds, setShowUsers, setShowPlaces }}
      {...props}
    />
  )
}
